// Toast text after a pool-queue rejection (item 191). Says only what the server actually does:
// an existing healer applying from the app gets no message; a new registration gets a rejection email.
export function poolRejectMessage(name, isExistingHealer) {
  const who = name ? name : 'The healer';
  return isExistingHealer
    ? 'Rejected. ' + who + ' is not notified automatically.'
    : 'Rejected. An email with your reason is being sent to ' + who + '.';
}
